module.exports = __webpack_public_path__ + "static/img/benefit1.78b4935.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/landingPage/bussiness/benefit1.png
// module id = Ii3l
// module chunks = 30